<template>
  <div v-if="showIframe" class="mobile-container">
    <div class="iframe-wrapper">
      <iframe
        :src="iframeSrc"
        frameborder="0"
        allowfullscreen
        class="mobile-iframe"
      ></iframe>
    </div>
    <button @click="closeIframe" class="close-btn">关闭</button>
  </div>
</template>

<script>
export default {
  props: {
    showIframe: {
      type: Boolean,
      required: true
    },
    iframeSrc: {
      type: String,
      required: true
    }
  },
  methods: {
    closeIframe() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* 将原样式部分复制到此处 */
.mobile-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  box-sizing: border-box;
}

.iframe-wrapper {
  position: relative;
  min-width: 450px;
  max-width: 90%;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border: 8px solid #e0e0e0;
  margin-bottom: 1.5rem;
}

.mobile-iframe {
  width: 100%;
  height: 70vh;
  min-height: 500px;
  max-height: 90vh;
  border: none;
  display: block;
}

.close-btn {
  padding: 0.75rem 1.5rem;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}

.close-btn:hover {
  background: #66b1ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}
</style>
